import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Global } from 'src/app/global/globalApi';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from 'src/app/models/Constants';

@Component({
  selector: 'app-logout-page',
  templateUrl: './logout-page.component.html',
  styleUrls: ['./logout-page.component.scss'],
})
export class LogoutPageComponent implements OnInit {
  constructor(private router: Router, public rootScope: RootScopeService) {
    this.rootScope.sessionExpiry = sessionStorage.getItem('sessionExpiry') ? true : false;
  }

  ngOnInit(): void { }

  logInAgain() {
    this.rootScope._isAuthenticated.next(false);
    this.rootScope._isLogout.next(false);
    let currentURL = window.location.href;
    if (currentURL.includes(Constants.LOCAL_ANGULAR_APIURL)) {
      window.location.href = Constants.LOCAL_ANGULAR_APIURL;
    } else
      window.location.href = `${Global.domainUrl}awcp/oauth2/authorization/pingidentity`;
    //this.router.navigate(['/login']);
  }
}
